import styled from "styled-components";
import { responsive } from 'Styles/Constants';
export const DashboardWrapper = styled.div`
    /* padding: 16px 32px 64px; */
    .project-list-pagination-container {
        z-index: 3;
        position: absolute;
        right: 0;
        bottom: 0;
        width: 100%;
    }

    .filter {
        margin : 0 0 0 auto;
    }

    .home-map-container {
        height: 90vh;
        width: 100%;
        /* padding: 50px; */

        ${responsive.LAPTOP`
            height: 90vh;
            padding: 0;
        `}

    }
`;